import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { BaseService } from '../base/base-service';
import { PostCommentPayload } from '../domain/post/post';


@Injectable({
    providedIn: 'root'
})
export class CommentsService extends BaseService {

    readonly uris = {
        createComment: `api/${environment.api.version}/additional-post-comments/create`,
        getComment: `api/${environment.api.version}/additional-post-comments/get`,
        deleteComment: `api/${environment.api.version}/additional-post-comments/delete`,
    };



    createComments(request: PostCommentPayload): Observable<any> {
        return this.http
            .post<any>(this.getUrl(`${this.uris.createComment}`, false), request)
            .pipe(
                switchMap(response => {
                    return [response];
                }),
                catchError(error => {
                    return [null];
                })
            );
    }

    getComments(payload: any): Observable<any> {
        return this.http
            .get<any>(this.getUrl(`${this.uris.getComment}/${payload.post_id}`, false))
            .pipe(
                switchMap(response => {
                    return [response];
                }),
                catchError(error => {
                    return [null];
                })
            );
    }

    deleteComments(id: number): Observable<any> {
        return this.http
            .delete<any>(this.getUrl(`${this.uris.deleteComment}/${id}`, false))
            .pipe(
                switchMap(response => {
                    return [response];
                }),
                catchError(error => {
                    return [null];
                })
            );
    }
}
